/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FeatureFlag {
    EXPENSE_BENCHMARK = 'expense_benchmark',
    HELLODATA = 'hellodata',
    MAKE_ORGANIZATION_VISIBLE = 'make_organization_visible',
    MAKE_PUBLIC = 'make_public',
    MEMBER_EXTERNAL_SHARING = 'member_external_sharing',
    PRICE_RECOMMENDATION = 'price_recommendation',
    THUMBNAIL_CUSTOMIZATION = 'thumbnail_customization',
    MARKET_FINDER = 'market_finder',
    REVENUE_MANAGEMENT = 'revenue_management',
    LEASED_PERCENT = 'leased_percent',
}
